import { render, staticRenderFns } from "./ListRelate.vue?vue&type=template&id=2ff34887&"
import script from "./ListRelate.vue?vue&type=script&lang=js&"
export * from "./ListRelate.vue?vue&type=script&lang=js&"
import style0 from "./ListRelate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Heading: require('/app/components/heading/Heading.vue').default,ListNewsItem: require('/app/components/list/ListNewsItem.vue').default})
